/* eslint-disable no-undef */
"use strict";
/**
 * Namespace for country list and conversions
 * @namespace pfKioskCountries
 */
var pfKioskCountries = {

    // Embedded, static country data for initial load
    defaultCountries: { 
        "countries": [{
          "name": "Australia",
          "spName": "Australia",
          "countryCode": "AU"
          }, {
              "name": "Canada",
              "spName": "Canadá",
              "countryCode": "CA"
          }, {
              "name": "Dominican Republic",
              "spName": "República Dominicana",
              "countryCode": "DO"
          }, {
              "name": "United States",
              "spName": "Estados Unidos",
              "countryCode": "US"
        }]
      }, 

    // Represents a list of country names and country codes provided by the club service.
    countries: [],
    onChangeCallback: {},
    dropdownSelector: {},

    /**
     * initDefaultCountries - Initializes country data from embedded, static list.
     * This list may not be correct. It's a place holder till the Club Service can
     * be contacted tp retrieve the correct list of countries.
     * @type {function}
     * @return None
     */
    initDefaultCountries: function() {
        pfKioskCountries.countries = [...pfKioskCountries.defaultCountries.countries];
    },

    /**
     * Country class - Encapsulates a country's name and country code.,
     * @type {function}
     * @return None
     */
    Country: function(enName, spName, countryCode) {
        this.Name = enName;
        this.spName = spName;
        this.Code = countryCode;
    },
  
    init: function(selector, onChangeCb) {
        var defaultCountry = {
            "name": "All",
            "spName": "All",
            "countryCode": ""
        };

        var $deferred = $.Deferred();
        
        if (selector && selector.length === 1) {
            pfKioskCountries.dropdownSelector = selector;    
        }
        // Set onchanged handler if necessary
        if (onChangeCb) {
            pfKioskCountries.onChangeCallback = onChangeCb;
        }

        $.ajax({
            method: "GET",
            retryCall: false,
            timeout:6 * 1000,
            url: config.CLUB_SERVICE + "/Clubs/CountryCodes?showAll=false",
            beforeSend: function (request, settings) {
                settings.url = settings.url.replace(/\+/g, "%20");
            },
            success: function (data) {
                pfKioskCountries.countries = [defaultCountry, ...data];
                $deferred.resolve();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                var err;
                if(jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.message){
                    err = jqXHR.responseJSON.message;
                    err = pfFetchTranslation('search.noResults');
                }
                $deferred.reject(err);
            }
        });
        return $deferred;
    },

    onClickCountryDropdown: function() {
        var cb = pfKioskCountries.onChangeCallback;
        var selector = pfKioskCountries.dropdownSelector;

        if (cb && selector && selector.length === 1) {
            var e = selector[0];
            var value = e.options[e.selectedIndex].value;
            var text = e.options[e.selectedIndex].text;
            var country = pfKioskCountries.countryByCode(value);
            cb(country);
        }
    },

    /**
     * clearCountryDropdownOptions - Clears the subordinate
     * option HTML objects programmatically.
     * @type {function}
     * @return None
     */
    clearCountryDropdownOptions: function()
    {
        var selector = pfKioskCountries.dropdownSelector;
        if (selector && selector.length === 1) {
            for(var i = selector[0].options.length - 1 ; i >= 0 ; i--)
            {
                selector[0].remove(i);
            }
        }
    },

    /**
     * populateCountryDropdown - Given a JQuery selector to a dropdown,
     * This will populate the dropdown with available countries.
     * @type {function}
     * @return $.Deferred
     */
    populateCountryDropdown: function()
    {
        var $deferred = $.Deferred();
        var selector = pfKioskCountries.dropdownSelector;

        if (selector && selector.length === 1) {
            // Clear any preexisting options
            pfKioskCountries.clearCountryDropdownOptions();

            // Repopulate options
            for(var i=0; i< pfKioskCountries.countries.length;i++) {
                var option = document.createElement("option");
                var country = pfKioskCountries.countries[i];
                option.value = country.countryCode;
                // Default the US choice
                // if (option.value === 'US') {
                //     option.selected = true;
                //     pfKioskAdmin.selectedSearchCountry =  pfKioskCountries.countryByCode('US');
                // }
                if (langLookup() === 'sp') {
                    option.text = `${country.spName} - ${country.countryCode}`
                }
                else {
                    option.text = `${country.name} ${country.countryCode ? "- "+country.countryCode : ""}`;
                }
                selector[0].appendChild(option);    
            }
            $deferred.resolve();
        }
        else {
            $deferred.reject('Bad selector passed to: populateCountryDropdown');
        }    
        return $deferred;
    },

    /**
     * countryByCode - returns a Country object given the country code.
     * @type {function}
     * @return Country name as string
     */
    countryByCode: function(countryCode) {
        return Enumerable.asEnumerable(pfKioskCountries.countries).Where(n => n.countryCode.toLowerCase() === countryCode.toLowerCase()).FirstOrDefault();
    },

    /**
     * countryByName - Returns the country object given a name.
     * @type {function}
     * @return Country code as string
     */
    countryByName: function(countryName) {
        return Enumerable.asEnumerable(pfKioskCountries.countries).Where(n => n.name.toLowerCase() === countryName.toLowerCase()).FirstOrDefault();
    },

     /**
     * allNames
     * @type {function}
     * @return Returns all country names supported as sorted array.
     */   
    allNames: function() {
        return Enumerable.asEnumerable(pfKioskCountries.countries).Select(n => n.name).OrderBy(n => n).ToArray();
    },

    /**
     * allNames
     * @type {function}
     * @return Returns all country codes supported as sorted array.
     */  
    allCodes: function() {
        return Enumerable.asEnumerable(pfKioskCountries.countries).Select(n => n.countryCode).OrderBy(n => n).ToArray();
    },
 };

if ( typeof module === 'object' && module.exports) {
    module.exports = pfKioskCountries;
}
